import React, { memo, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { actionsList } from "../../services/actions";

import Pagination from "../../components/shared/pagination";
import { SortBar, SearchBar } from "../../components/FilterBar";

export const ExerciseListPage = () => {
  const navigate = useNavigate();

  const add = () => navigate("/club_admin/actions/new");
  const select = (item) => navigate(`/club_admin/actions/${item.id}`);

  return <ActionsList select={select} add={add}/>
}

export default memo(ExerciseListPage);

export const ActionsList = ({ select, add }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const getFilterValue = (param, defaultValue) => searchParams.get(param) || defaultValue;
  const initialFilters = {
    page: Number(getFilterValue("page", 1)),
    per_page: 10,
    owner_type: getFilterValue("owner_type", "club"),
    sort_dir: getFilterValue("sort_dir", 'asc'),
    sort_by: 'title',
    q: getFilterValue("q", ""),
  };
  const [filters, setFilters] = useState(initialFilters);
  const [actions, setActions] = useState([]);
  const [count, setCount] = useState(0);
  const { owner_type } = filters;
  const { t } = useTranslation();

  const updateSearchParams = (newFilters) => {
    const updatedParams = new URLSearchParams(searchParams);
    
    Object.entries(newFilters).forEach(([key, value]) =>
      value ? updatedParams.set(key, value) : updatedParams.delete(key)
    );
  
    setSearchParams(updatedParams);
  };
  
  const loadData = async () => {
    const { actions, count } = await actionsList(filters);
    setActions(actions);
    setCount(count);
  };

  useEffect(() => {
    updateSearchParams(filters);
    loadData();
  }, [filters]);

  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }) }, [filters?.page]);

  return (
    <div className="teams">
      <div className="teams-header">
        <div className="teams-header-text pointer">{t("actions.actions")}</div>
        {add && <button className="button button-add" onClick={add}>{t("buttons.action.add")}</button>}
      </div>

      <div className="team-details-tabs margin-top">
        <div className={`team-details-tabs-option pointer ${owner_type === "club" ? 'active' : ''}`} onClick={() => owner_type !== 'clubs' && setFilters({...filters, owner_type: 'club', page: 1 })}>{t('actions.club')}</div>
        <div className={`team-details-tabs-option pointer ${owner_type === "supercoach" ? 'active' : ''}`} onClick={() =>  owner_type !== 'supercoach' && setFilters({...filters, owner_type: 'supercoach', page: 1 })}>{t('actions.supercoach')}</div>
      </div>
      <div className="filters-bar">
        <SortBar onSortChange={(sort_dir) => setFilters({...filters, sort_dir, sort_by: sort_dir ? 'title' : null })} direction ={filters.sort_dir} />
        <SearchBar 
          onChange={(q) => setFilters({ ...filters, page: 1, q })}
          placeholder={t("actions.placeholder")}
          value={filters.q}  
        />
      </div>

      <div className="library-list-container list-view">
        {actions.map(action => (
          <div key={action.id} className="library-item">
            <div className="library-item-preview pointer" onClick={() => select(action)}>
              <img src={action.video_preview_image_app_url} className="fit-image" alt={action.title} />
            </div>
            <div className="library-item-info">
              <div className="flex-between1">
                <div className="library-item-info-title pointer" onClick={() => select(action)}>
                  {action.title}
                </div>
                <div>
                  <span className={`new_label new_label-${action.published ? "success" : "default"}`}>
                    {action.published ? t("common.published") : t("common.draft")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Pagination filters={filters} count={count} onChange={setFilters} />
    </div>
  );
};
